import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button} from 'views/components';
import {AddCircleOutline as AddCircleOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';

import AddNewContact from './AddNewContact';
import CaregiverContact from './CaregiverContact';

const CaregiverContacts = (props) => {
  const [isAdding, setIsAdding] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
  } = props;

  const contacts = Object.values(caregiverData.contacts);

  return (
    <>
      <Stack
        spacing={2}
        sx={{
          pb: 2,
        }}
      >
        {
          contacts.map((contact, index) => {
            return (
              <CaregiverContact
                key={index}
                contact={contact}
                caregiverData={caregiverData}
                caregiverBackend={caregiverBackend}
              />
            );
          })
        }
        <Button
          startIcon={<AddCircleOutlineIcon />}
          onClick={() => setIsAdding(true)}
        >
          <Translate expression='caregiver.CaregiverDetail.Settings.Contact.CreateNew.Action' />
        </Button>
        {
          isAdding &&
          <AddNewContact
            caregiverData={caregiverData}
            caregiverBackend={caregiverBackend}
            isEditing={isAdding}
            setIsEditing={setIsAdding}
          />
        }
      </Stack>
    </>
  );
};

CaregiverContacts.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(CaregiverContacts);
